import React from "react";
import { AlertDialogCloseButton } from "@chakra-ui/react";

export const AlertCloseButton = (): JSX.Element => {
  return <AlertDialogCloseButton />;
};
